// @flow
import PlainDateMonthPicker, { type DateMonthPickerProps } from './plain-date-month-picker';

export default PlainDateMonthPicker;
export type { DateMonthPickerProps };
